(() => {
  if (customElements.get('bobbo-recommendations')) return;
  customElements.define('bobbo-recommendations', class extends HTMLElement {
    connectedCallback() {
      this.initializeImages();
      if (!('IntersectionObserver' in window)) {
        this.hydrateImages();
        this.load();
        return;
      }
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.observer.disconnect();
          this.hydrateImages();
          this.load();
        }
      }, {rootMargin: '400px'});
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
    }
    hydrateImages() {
      // DOMParser treats noscript markup as elements in section responses.
      // Keep that fallback only when JavaScript is actually disabled.
      this.querySelectorAll('noscript').forEach(fallback => fallback.remove());
      this.querySelectorAll('template[data-recommendation-image]').forEach(template => {
        const content = template.content.cloneNode(true);
        const image = content.querySelector('img');
        if (image) image.loading = 'eager';
        template.replaceWith(content);
      });
      this.initializeImages();
    }
    initializeImages() {
      this.querySelectorAll('.img-second').forEach(image => {
        if (image.dataset.recommendationReady) return;
        image.dataset.recommendationReady = 'true';
        const update = () => image.closest('.card__media')?.classList.toggle('reference-hover-ready', image.complete && image.naturalWidth > 0);
        image.addEventListener('load', update);
        image.addEventListener('error', update);
        update();
      });
    }
    async load() {
      if (this.dataset.loaded) return;
      this.dataset.loaded = 'loading';
      this.controller = new AbortController();
      const timeout = setTimeout(() => this.controller.abort(), 10000);
      try {
        const response = await fetch(this.dataset.url, {signal: this.controller.signal});
        if (!response.ok) throw new Error('Recommendations unavailable');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = document.querySelector('bobbo-recommendations');
        if (this.isConnected && replacement?.dataset.source === 'shopify' && replacement.querySelector('[data-reference-card]')) {
          // Keep the server-rendered fallback if the visitor has started using it.
          if (!this.contains(window.document.activeElement)) {
            this.replaceChildren(...replacement.childNodes);
            this.dataset.source = 'shopify';
            this.hydrateImages();
          }
        }
        this.dataset.loaded = 'true';
      } catch {
        // Collection recommendations already render without this request or JavaScript.
        this.dataset.loaded = 'fallback';
      } finally {
        clearTimeout(timeout);
      }
    }
  });
})();
